import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button } from 'ui/styled';
import { PhoneOutlined } from '@ant-design/icons';
import { selectIsWindowOpen, useNicStore } from 'stores/nic/stores/nicStore';
/**
 * Header toggle for the NIC window. Safe to mount per page — it holds no call
 * state; the window itself lives in `NICWindow`, mounted once in the app shell.
 */
var NICMain = function () {
    var isWindowOpen = useNicStore(selectIsWindowOpen);
    var setIsWindowOpen = useNicStore(function (state) { return state.setWindowOpen; });
    return (_jsx(Button, { onClick: function () { return setIsWindowOpen(!isWindowOpen); }, margin: "0 12px 0 0", btnsize: "custom", padding: "8px 12px", children: _jsx(PhoneOutlined, {}) }));
};
export default NICMain;
